export default function TrustBar() {
  const items = [
    { icon: 'ri-map-pin-2-line', label: 'Richmond Area Local Experts' },
    { icon: 'ri-focus-3-line', label: 'Industry-Specialized — Not Generalists' },
    { icon: 'ri-line-chart-line', label: 'Proactive Monthly Insights' },
    { icon: 'ri-shield-check-line', label: 'Secure Cloud-Based Tools' },
    { icon: 'ri-apps-line', label: 'QuickBooks & Xero Proficient' },
  ];

  return (
    <section className="bg-background-100 border-y border-background-200/60">
      <div className="w-full px-4 md:px-8 lg:px-12 py-5 md:py-6">
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
          {items.map((item) => (
            <div key={item.label} className="flex items-center gap-2 text-foreground-600">
              <div className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-100/80">
                <i className={`${item.icon} text-accent-600 text-sm`} />
              </div>
              <span className="text-sm font-medium whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}